<template>
  <div>
    <DeleteModal
      modal-id="modal-out-invoice-delete"
      @deleteToggle="deleteItem"
    />

    <b-modal
      id="modal-out-invoice-edit"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('clinic.Add Patient Out Clinic Invoice')
          : $t('clinic.Edit Patient Out Clinic Invoice')
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <div class="mt-2 mt-md-0 w-100 mx-1">
            <ServicePriceAutoComplete
              v-model="selectedService"
              :label="$t('hospital.services')"
              :placeholder="$t('hospital.services')"
              :serializer="(val) => val"
              param-query="search"
              text-title="title"
              :disable-amount="true"
              @val="serviceValue($event)"
            />
          </div>
          <b-col v-if="false" md="12" class="mt-2">
            <AutoComplete
              v-model="EditForm.doctor_id"
              :label="
                $t('common.doctor-filter') + ' (' + $t('common.optional') + ')'
              "
              :placeholder="$t('common.doctor-filter')"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="doctor"
              text-title="name"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card>
      <div>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("clinic.Patient Out Clinic Invoice") }}</h2>

          <b-button
            v-if="!isHistory"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("clinic.Add Patient Out Clinic Invoice") }}
          </b-button>
        </div>

        <b-table
          v-if="!loading"
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
        >
          <template #cell(amount)="data">
            <span class="text-nowrap"> {{ data.item.amount }} IQD </span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <!-- @click="printId(data.item.id)" -->

              <!-- Dropdown -->
              <ActionsButtons
                v-if="!isHistory"
                :no-edit="true"
                :no-delete="true"
                delete-perm=""
                edit-perm=""
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
              <!-- <b-dropdown
                variant="link"
                toggle-class="p-0"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item
                  @click="deleteModel(data.item)"

                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
              </b-dropdown> -->
              <!-- <b-button
                v-print="OutClinicInvoice"
                @click="printInvoice(data.item)"
                variant="outline-primary"
                class="mx-4"
                size="sm"
                pill
              >
                {{ $t('reception.Print Invoice') }}
              </b-button> -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getPatientInvoiceOutClinic()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
    <OutClinicInvoice :data="invoice" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const OutClinicInvoice = () =>
  import("@/components/printables/OutClinicInvoice.vue");
const ServicePriceAutoComplete = () =>
  import("@/components/common/ServicePriceAutoComplete.vue");

export default {
  components: {
    DeleteModal,
    ServicePriceAutoComplete,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    AutoComplete,
    OutClinicInvoice,
  },

  props: ["patientCardId", "isHistory"],
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      selectedService: null,
      EditForm: {
        patient_card_id: "",
        doctor_id: "",
        amount: 0,
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        patient_card_id: this.$route.params.id,
        service_id: "",
        amount: 0,
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "service.title",
          label: this.$t("reception.service"),
          sortable: true,
        },
        {
          key: "amount",
          label: this.$t("employee.amount"),
          sortable: true,
        },

        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created-at"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      invoice: "",
      patientData: {
        name: this.$route.params.name,
      },
      OutClinicInvoice: {
        id: "OutClinicInvoice",
      },
      invoices: [],
    };
  },
  mounted() {
    this.getPatientInvoiceOutClinic();
  },
  methods: {
    printInvoice(item) {
      this.invoice = item;
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.selectedService = null;
        this.EditForm = {
          patient_card_id: this.$route.params.id,
          doctor_id: null,
          amount: 0,
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.patient_card_id = this.$route.params.id;
        this.EditForm.service_id = item.service_id || this.service_id;
        this.EditForm.doctor_id = item.doctor_id || null;
        this.EditForm.amount = item.amount;
        this.EditForm._method = "PUT";
        // Set selected service for edit mode if service data is available
        if (item.service) {
          this.selectedService = item.service;
        }
      }
      this.$bvModal.show("modal-out-invoice-edit");
    },
    serviceValue(service) {
      if (service && service.id) {
        this.EditForm.service_id = service.id;
        this.EditForm.amount = service.price || 0;
        // Force reactivity update
        this.$set(this.EditForm, "service_id", service.id);
        this.$set(this.EditForm, "amount", service.price || 0);
      }
    },
    async getPatientInvoiceOutClinic() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      const url = `/invoices?filter[type]=invoice_out_clinic&filter[patient_card_id]=${this.$route.params.id}&page=${this.page}&take=${this.take}&sort=-id&include=patientCard,service`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-out-invoice-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/invoices/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientInvoiceOutClinic();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: `deleted ${this.deleteForm.service.title} successfully`,
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: `Error deleting ${this.deleteForm.service.title}`,
            },
          });
        });
    },
    submitItem() {
      for (const item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        this.EditForm.patient_card_id = this.$route.params.id;
        this.EditForm.type = "invoice_out_clinic";

        this.invoices.push(this.EditForm);

        (this.params.form = { invoices: this.invoices }),
          (this.params.path = "/invoices"),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.invoices = [];
              this.getPatientInvoiceOutClinic();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (const item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/invoices/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getPatientInvoiceOutClinic();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (const item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
